import React from 'react';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { confirmResetPassword } from 'aws-amplify/auth';
import './Login.scss';
import giggLogo from '../../../images/gigg-logo.svg';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';

export default function ResetPassword({ code: resetCode, email }: { code: string; email: string }) {
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  if (!resetCode || !email) {
    navigate('/login');
    return null;
  }

  const onSubmitPassword = async (values: any) => {
    setLoading(true);

    if (!resetCode || !email) {
      setLoading(false);
      navigate('/login');
      return;
    }

    const { password, confirm } = values;

    if (password !== confirm) {
      setLoading(false);
      message.error('Passwords do not match');
      return;
    }

    try {
      await confirmResetPassword({
        username: email,
        confirmationCode: resetCode,
        newPassword: confirm,
      });
      setLoading(false);
      message.success('Password was successfully reset');
      navigate('/login');
    } catch (error) {
      console.error(error);
      message.error((error as Error).message);
      setLoading(false);
    }

    setLoading(false);
  };

  return (
    <div className="flex-container justify-center router-wrapper">
      <div className="login-outer">
        <div className="flex-container justify-center">
          <div className="margin-bottom-md">
            <div className="login-image-container">
              <Link to={'/login'}>
                <img className="login-img" src={giggLogo} width="100%" height="auto" alt="Gigg" />
              </Link>
            </div>
            <div className="flex-container justify-center">Reset Password</div>
          </div>
        </div>
        <div className="login-inner">
          <Form layout="vertical" className="login-form" onFinish={onSubmitPassword}>
            <Form.Item
              name={'password'}
              rules={[
                {
                  required: true,
                  message: 'Please input your password',
                },
              ]}
            >
              <Input className="login-input" type="password" placeholder="Password" />
            </Form.Item>
            <Form.Item
              name={'confirm'}
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password',
                },
              ]}
            >
              <Input className="login-input" type="password" placeholder="Confirm Password" />
            </Form.Item>
            <div className="flex-container margin-bottom-md">
              <div className="flex-container flex">
                <Button className="login-button" htmlType="submit">
                  {loading ? (
                    <FontAwesomeIcon icon={faSpinnerThird} size="lg" className="fa-fast-spin" />
                  ) : (
                    <span>Change Password</span>
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
